import ModuleContent from "features/shared/layout/content/ModuleContent";
import Header from "features/shared/layout/header/Header";
import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router-dom";
import PlaceOfDeliveryConsumptionDetailSection from "features/placeOfDelivery/sections/PlaceOfDeliveryConsumptionDetailSection";
import { useSearchParams } from "features/shared/hooks/useSearchParams";
import BreadcrumbLink from "features/shared/components/breadcrumbs/BreadcrumbLink";

type Props = {
  placeOfDeliveryId: string;
};

const ConsumptionHistoryDetail = (props: Props) => {
  // translations
  const { t } = useTranslation(["shared\\moduleNames"]);

  // router
  const { placeOfDeliveryId } = useParams<Props>();
  const location = useLocation<number>();
  const searchParams = useSearchParams();

  // helpers
  const isProduction = (): boolean => { 
    let isProduction = searchParams.get("isProduction");
    if (isProduction != null) {
      return isProduction === "true";
    }

    return false;
  }

  const getTitle = () => { 
    if (isProduction()) {
      return t("placeOfDeliveryProductionDetail.title");
    } else {
      return t("placeOfDeliveryConsumptionDetail.title");
    }
  }

  const getBreadcrumbLink = (): BreadcrumbLink => { 
    if (isProduction()) {
      return { text: t("productionHistory.title"), to: "/production-history" };
    } else {
      return { text: t("consumptionHistory.title"), to: "/consumption-history" };
    }
  }

  // render
  return (
    <>
      <Header
        title={getTitle()}
        subtitle={placeOfDeliveryId}
        includeBreadcrumbs
        links={[getBreadcrumbLink()]}
      />
      <ModuleContent>
        <PlaceOfDeliveryConsumptionDetailSection
          placeOfDeliveryId={placeOfDeliveryId}
          year={location.state}
          isProduction={isProduction()}
        />
      </ModuleContent>
    </>
  );
};

export default ConsumptionHistoryDetail;
